export default __webpack_public_path__ + "static/media/github.b98ee211.png";